import { useState } from 'react';
import type { CategoryInfo } from '@/types';
import type { SortKey, RangeKey } from '@/utils/data';

const ranges: { key: RangeKey; label: string }[] = [
  { key: 'all', label: '全部时间' },
  { key: 'today', label: '今天' },
  { key: '3d', label: '近三天' },
  { key: '7d', label: '近一周' },
];

const sorts: { key: SortKey; label: string }[] = [
  { key: 'latest', label: '最新' },
  { key: 'hot', label: '最热' },
  { key: 'views', label: '最多阅读' },
];

interface FilterBarProps {
  category: CategoryInfo;
  sub: string;
  range: RangeKey;
  sort: SortKey;
  onSubChange: (v: string) => void;
  onRangeChange: (v: RangeKey) => void;
  onSortChange: (v: SortKey) => void;
}

export default function FilterBar({ category, sub, range, sort, onSubChange, onRangeChange, onSortChange }: FilterBarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb-6">
      <div className="flex lg:hidden items-center justify-between mb-3">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 cursor-pointer"
        >
          <i className="ri-filter-3-line" /> 筛选条件
          <i className={open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
        </button>
        <span className="text-sm text-foreground-400">共 {sorts.length} 种排序</span>
      </div>

      <div className={`${open ? 'block' : 'hidden'} lg:block space-y-4`}>
        <div>
          <p className="text-xs text-foreground-400 mb-2">子分类</p>
          <div className="flex flex-wrap items-center gap-2">
            {category.subcategories.map((s) => (
              <button
                key={s.slug}
                type="button"
                onClick={() => onSubChange(s.slug)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  sub === s.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600'
                }`}
              >
                {s.name}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div>
            <p className="text-xs text-foreground-400 mb-2">时间区间</p>
            <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100">
              {ranges.map((r) => (
                <button
                  key={r.key}
                  type="button"
                  onClick={() => onRangeChange(r.key)}
                  className={`px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                    range === r.key ? 'bg-background-50 text-primary-600 font-medium' : 'text-foreground-600 hover:text-primary-600'
                  }`}
                >
                  {r.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs text-foreground-400 mb-2">排序方式</p>
            <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100">
              {sorts.map((s) => (
                <button
                  key={s.key}
                  type="button"
                  onClick={() => onSortChange(s.key)}
                  className={`px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                    sort === s.key ? 'bg-background-50 text-primary-600 font-medium' : 'text-foreground-600 hover:text-primary-600'
                  }`}
                >
                  {s.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}